import Vue from 'vue';
import axios from 'axios';

export const healthConsentBus = new Vue();

let pendingResolver = null;
let pendingUserId = null;

const STORAGE_KEY_PREFIX = 'rxpros_health_consent_accepted';

function consentKey(userId) {
    return userId ? `${STORAGE_KEY_PREFIX}_${userId}` : STORAGE_KEY_PREFIX;
}

export function hasAcceptedHealthConsent(userId) {
    try {
        return localStorage.getItem(consentKey(userId)) === '1';
    } catch (e) {
        return false;
    }
}

export function requestHealthConsent(userId) {
    if (hasAcceptedHealthConsent(userId)) {
        return Promise.resolve(true);
    }

    if (pendingResolver) {
        const previous = pendingResolver;
        pendingResolver = null;
        previous(false);
    }

    return new Promise((resolve) => {
        pendingResolver = resolve;
        pendingUserId = userId || null;
        healthConsentBus.$emit('hic-open');
    });
}

export function resolveHealthConsent(accepted) {
    if (accepted) {
        try {
            localStorage.setItem(consentKey(pendingUserId), '1');
        } catch (e) { /* ignore storage errors */ }
        logHipaaAccept();
    }
    if (!pendingResolver) {
        pendingUserId = null;
        healthConsentBus.$emit('hic-close');
        return;
    }
    const resolver = pendingResolver;
    pendingResolver = null;
    pendingUserId = null;
    resolver(!!accepted);
    healthConsentBus.$emit('hic-close');
}

function logHipaaAccept() {
    const base = process.env.VUE_APP_API_ENDPOINT;
    if (!base) return;
    axios.get(`${base}/api/accept-hippa`).catch((err) => {
        // NOTE: audit-log fire-and-forget; don't block user if backend hiccups
        console.error('accept-hippa log failed', err);
    });
}
